module.exports = __webpack_public_path__ + "static/media/gallery-img-5.bd57fd27.jpg";